import { Statistics } from './evaluation';

export enum SpeechType {
  GOOD,
  BAD,
}

export const SpeechTypeText = {
  [SpeechType.GOOD]: '高',
  [SpeechType.BAD]: '低',
};

export enum SpeechSource {
  TEACHING_POINT,
}

export interface Speech {
  id: number;
  content: string;
  source: SpeechSource;
  sourceId: number;
  type: SpeechType;
  knowledgeName: string;
}

export interface EnrollmentReport {
  knowledgePoints: Statistics[];
  lessonNames: string[];
}



// WEBPACK FOOTER //
// ./src/types/speech.ts